import type { ReactElement } from 'react'

/** The web form brings its own Elements provider. */
export const StripeRoot = ({ children }: { children: ReactElement }) => children
